<template>
  <div class="background-01">

    <v-layout row wrap>
      <v-flex xs12 sm2 md2 class="hidden-xs-only ">
        <image-app class="animated fadeInLeft" :imaSize="300" imaSrc="design/banco1-1-3" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm9 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="Existen diferentes tipos de gastos" titleLevel="h1">
          <template slot="partOne">Otra división<br></template>
          <template slot="partThree"> de los gastos</template>
        </ui-title-one>
      </v-flex>
    </v-layout>

    <v-layout row wrap class="animated fadeInUp dura_1">
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc  :vidTittle="'Gastos ocultos y gastos discrecionales'" videoEmbed="ADMINISTRACIONDINERO30DiferentesTiposDeGastosc.mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12>
        <p>Dentro de los <strong>gastos esenciales y no esenciales</strong> existen otro tipo de gastos denominados <strong>gastos ocultos y gastos discrecionales.</strong><br><br>
          <span class="offscreen">Pase el cursor o dé enter sobre cada tipo de gasto para descubrir su definición</span></p>
      </v-flex>
    </v-layout>

    <button-expand-cont class="animated fadeInUp dura_2" :contenidos="contenidos"></button-expand-cont>

  </div>
</template>

<script>
export default {
  data() {
    return {
      contenidos: [
        {
          nombre: 'Gastos ocultos',
          texto: `Se presentan con la adquisición de un artículo y con frecuencia <strong>no se tienen en cuenta</strong>;
          por ejemplo, si compra carro, debe pagar seguros, reparaciones, impuestos, gasolina,
          mantenimiento, parqueadero, llantas, entre otros.`,
          visto: false
        },
        {
          nombre: 'Gastos discrecionales',
          texto: `Son los que la persona decide hacer y de los cuales tiene <strong>total control</strong> sobre la cantidad a gastar.
          Por ejemplo, diversiones, ropa o regalos, entre otros.`,
          visto: false
        }
      ]
    };
  },
  mounted() {
    this.$store.commit("nextShow", false);
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-30.vue?020d8353